import ReactRenderButtonBlock from "../Blocks/Button";
import ReactRenderContainerBlock from "../Blocks/Container";
import ReactRenderHeadingBlock from "../Blocks/Heading";
import ReactRenderImageBlock from "../Blocks/Image";
import ReactRenderParagraphBlock from "../Blocks/Paragraph";

const BLOCKS = [
	ReactRenderHeadingBlock,
    ReactRenderParagraphBlock,
    ReactRenderImageBlock,
    ReactRenderContainerBlock,
    ReactRenderButtonBlock
];

class DynamicRenderBlock {
	constructor() {
		this.init()
	}
    init() {
        BLOCKS.forEach(callback => callback());
    }
}

export default DynamicRenderBlock;
